exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.my-autocomplete {\nli {\n    line-height: normal;\n    padding: 7px;\n.pop_header {\n      text-overflow: ellipsis;\n      overflow: hidden;\n}\n.pop_body {\n      font-size: 12px;\n      color: #909090;\n      display: block;\n}\n}\n}\n.el-popover {\n  word-break: keep-all\n}\n", ""]);

// exports
